import type { BillingSubscription, BillingSubscriptionResponse } from '@/types/billing'

/**
 * Normalizes subscription API response to canonical BillingSubscription.
 * Maps legacy field names to new API names for backward compatibility during rollout.
 */
export function normalizeSubscription(
  api: BillingSubscriptionResponse
): BillingSubscription {
  return {
    id: api.id,
    planTier: api.planTier ?? null,
    status: api.status,
    cancelAtPeriodEnd: api.cancelAtPeriodEnd,
    canceledAt: api.canceledAt,
    currentPeriodStart: api.currentPeriodStart,
    currentPeriodEnd: api.currentPeriodEnd,
    pricingModel: api.pricingModel,
    usedSlots: api.usedSlots ?? api.activePlaybookCount,
    confirmedQuota: api.confirmedQuota ?? api.playbookCount,
    usableQuota: api.usableQuota ?? api.effectivePlaybookCount ?? api.totalQuota ?? api.playbookCount,
    scheduledQuota: api.scheduledQuota ?? api.targetPlaybookCount ?? api.playbookCount,
    hasPendingDecrease: api.hasPendingDecrease,
    hasPendingIncrease: api.hasPendingIncrease ?? api.hasPendingPlaybookIncrease,
    pendingQuota: api.pendingQuota ?? api.pendingPlaybookCount,
    freeQuota: api.freeQuota ?? api.freePlaybookCount,
    freeQuotaUsed: api.freeQuotaUsed ?? api.freePlaybookQuotaUsed
  }
}
